var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"word",class:{'video-cut': _vm.isVideoCut, 'high':_vm.isConfidenceHigh, 'medium':_vm.isConfidenceMedium, 'low':_vm.isConfidenceLow},staticStyle:{"z-index":"-1"},attrs:{"data-start":_vm.startTime,"data-end":_vm.endTime,"data-position":_vm.position,"data-confidence":_vm.confidence}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }